import {
  Blockquote,
  Bold,
  BulletList,
  CodeBlockHighlight,
  Heading,
  ListItem,
  Strike,
  Placeholder,
  Link,
  TrailingNode,
  History,
  Collaboration,
} from 'tiptap-extensions';
import { CustomDoc as Doc } from '@/components/editor/Doc';
import { Title } from '@/components/editor/Title';

const editorConfig = {
  defaultExtensions: () => [
    new Doc(),
    new Title(),
    new Link(),
    new Blockquote(),
    new Bold(),
    new BulletList(),
    new CodeBlockHighlight(),
    new Heading({ levels: [2] }),
    new ListItem(),
    new Strike(),
  ],
};

export default editorConfig;
